//import Vue from 'vue'
//import OneSignalVue from 'onesignal-vue'
import config from '../config'
import OneSignal from 'onesignal-cordova-plugin';
import { Capacitor } from "@capacitor/core";

let isSet = false
function setExternalUserId(token){
  try {
    if (isSet && Capacitor.isNativePlatform()) {
      OneSignal.setExternalUserId(token)
      console.log('token set', token)
    }
  }catch(e){}
}

function setSMSNumber(phone){
  try {
    if (isSet && Capacitor.isNativePlatform()) {
      OneSignal.setSMSNumber(('+31' + phone).replace('+3106','+316'))
      console.log('Num,ber set', ('+31' + phone).replace('+3106','+316'))
    }
  }catch(e){}
}

// Call this function when your app starts
function OneSignalInit(token,phone) {
  try {

    if (isSet || !Capacitor.isNativePlatform()) return false
    // Uncomment to set OneSignal device logging to VERBOSE  
    // OneSignal.setLogLevel(6, 0);
    // NOTE: Update the setAppId value below with your OneSignal AppId.
    OneSignal.setAppId(config.oneSignal.appId);
    if (token) OneSignal.setExternalUserId(token)
    if (phone) OneSignal.setSMSNumber(('+31' + phone).replace('+3106','+316'))
    OneSignal.setNotificationOpenedHandler(function(jsonData) {
        console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
    });
    /*OneSignal.getIds().then(identity => {
      alert(identity.pushToken + " It's Push Token");
      alert(identity.userId + " It's Devices ID");
    });*/
    // iOS - Prompts the user for notification permissions.
    //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 6) to better communicate to your users what notifications they will get.
    OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
        console.log("User accepted notifications: " + accepted);
    });
    isSet = true
  }catch(e){
    console.log('signal erro' , e)
  }
  }
export {OneSignalInit, setExternalUserId, setSMSNumber}